module.exports = __webpack_public_path__ + "img/icon-like.31732849.png";